/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgRoadsideAssit248(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M13.18 25.5H6.704a2.723 2.723 0 00-2.722 2.723V37h9.901'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M20.5 22h-6.335a.787.787 0 00-.786.787V37M18.343 36.8V25'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M10.5 42H4v3.553C4 46.352 4.648 47 5.447 47h3.606c.799 0 1.447-.648 1.447-1.447V42z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M20.5 8.25H8.531c-.569 0-1.031.462-1.031 1.031V25.25M8 18h12.5M7.446 32H10.5M20.5 37H2v5h18.5M11.5 4.5v4M7 18H4.06C3.476 18 3 17.562 3 17.021V12.98c0-.541.474-.979 1.06-.979H7M27.82 25.5h6.475a2.723 2.723 0 012.723 2.723V37h-9.901'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M20.5 22h6.334c.436 0 .788.352.788.787V37M22.657 36.8V25'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M30.5 42H37v3.553c0 .799-.648 1.447-1.447 1.447h-3.605c-.8 0-1.448-.648-1.448-1.447V42z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M20.5 8.25h11.968c.57 0 1.032.462 1.032 1.031V25.25M33 18H20.5M30.5 32h3.054M20.5 37H39v5H20.5M29.5 4.5v4M34 18h2.94c.586 0 1.06-.438 1.06-.979V12.98c0-.541-.474-.979-1.06-.979H34'
      />
      <path
        stroke='currentColor'
        strokeWidth={1.5}
        d='M31.934 8.309l11.113-6.304a.3.3 0 01.411.404c-1.212 2.22-4.862 8.04-4.862 8.04M43.5 2.293V13.75a1.75 1.75 0 103.5 0v-3.024'
      />
    </svg>
  );
}

export default SvgRoadsideAssit248;
